import Splide from '@splidejs/splide';

const SELECTORS = {
    block: '.wp-block-ssm-podcast-feed',
    carousel: '.splide',
    arrows: '.splide__arrows',
};

const DEFAULT_OPTIONS = {
    gap: '2rem',
    arrows: true,
    pagination: false,
    autoWidth: true,
};

export function initPodcastFeed(block, isEditor = false) {
    const carousel = block.querySelector(SELECTORS.carousel);

    if (!carousel || carousel.splide) {
        return null;
    }

    try {
        const splide = new Splide(carousel, {
            ...DEFAULT_OPTIONS,
            ...(isEditor ? { drag: false } : {}),
        });

        splide.on('overflow', function (isOverflow) {
            try {
                const arrows = splide.Components.Elements.arrows;
                arrows.classList.toggle('hidden', !isOverflow);
            } catch (error) {
                console.error('No arrows found in carousel', error, carousel);
            }
        });

        splide.mount();

        return () => {
            if (splide && typeof splide.destroy === 'function') {
                splide.destroy();
            }

            delete carousel.splide;
        };
    } catch (error) {
        console.error('Error initializing Podcast feed carousel:', error, carousel);

        return null;
    }
}

export function PodcastFeed() {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initPodcastFeed(block);
    });
}
